import { render, staticRenderFns } from "./RepairRefStandardized.vue?vue&type=template&id=95199b08&scoped=true"
import script from "./RepairRefStandardized.vue?vue&type=script&lang=js"
export * from "./RepairRefStandardized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95199b08",
  null
  
)

export default component.exports